import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { getCountriesWithCoordinates } from "../services/countries.service";

export const useGetCountriesWithCoordinates = () => {
  const { i18n } = useTranslation();

  const {
    data,
    isLoading: isCountriesWithCoordinatesLoading,
    isError: isCountriesWithCoordinatesError,
  } = useQuery({
    queryKey: ["CountriesWithCoordinates", i18n.language],
    queryFn: getCountriesWithCoordinates,
    refetchOnMount: "always",
  });

  const countriesWithCoordinates = data?.data?.items || [];

  return {
    countriesWithCoordinates,
    isCountriesWithCoordinatesLoading,
    isCountriesWithCoordinatesError,
  };
};
